<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("calculators_common.platforms") }}
    </h4>
    <div class="d-flex-row space-between  platform_picker_container gap-10">
      <button
        v-for="platform in getGame?.platforms"
        :key="platform.title"
        class="d-flex-row flex-2 platform_picker"
        @click.stop="() => selectPlatform(platform)"
        :class="[
          checkoutStore.getSelectedPlatform === platform.id && 'selected',
        ]"
      >
        <img
          class="role_icon"
          alt="Game platform image"
          :src="platform.image_dark"
        />
        <p class="font-family-2 medium-l white-space-no" v-if="!$isMobile()">
          {{ platform.title }}
        </p>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },

  methods: {
    selectPlatform(platform) {
      this.checkoutStore.setPlatform({
        platform: platform.id,
      });
    },
  },
  setup() {
    const { getGame } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGame,
      checkoutStore,
    };
  },
};
</script>
